module.exports = __webpack_public_path__ + "static/profilePic2-bb91af9fd2826812f49c01fbaefa6070.jpg";